'use strict'

# coffee goes here

# Remember to call Groupon.Performance.pageReady() when the page is completely
# loaded. This will send performance data to Optimize.
#
# More context is available at:
# https://pages.github.groupondev.com/InteractionTier/framework/optimize.html
#
# Sample code:
# window.addEventListener 'load', ->
#   Groupon.Performance.pageReady()

require '../common/underscore_mixins'
require '../common/backbone_init'
